import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';
import type { SelectedDeploymentPriorityProfile, SelectedProfileData } from './ConfigurationProfileListPage.model';

export const openConfigurationProfileCreateModalAtom: PrimitiveAtom<boolean> = atom(false);

export const selectedActionAtom: PrimitiveAtom<string | undefined> = atom(undefined as string | undefined);
export const selectedConfigurationProfileIdAtom: PrimitiveAtom<SelectedProfileData | undefined> = atom(
  undefined as SelectedProfileData | undefined,
);

export const openEditDeploymentPriorityModalAtom: PrimitiveAtom<boolean> = atom(false);
export const selectedDeploymentPriorityProfileAtom: PrimitiveAtom<SelectedDeploymentPriorityProfile | undefined> = atom(
  undefined as SelectedDeploymentPriorityProfile | undefined,
);
